import { Text } from '@pentabd/ui';
import { Link } from 'react-router-dom';

function NoMatch() {
  return (
    <div
      className="text-center w-100 vh-100 d-flex 
    flex-column align-items-center justify-content-center"
    >
      <Text component="p">Nothing to see here!</Text>
      <Link to="/">Go to the home page</Link>
    </div>
  );
}

export default NoMatch;
